export function isImportMetaServer(): boolean {
  return !!import.meta.server;
}
